import { useMemo } from 'react'

import { AsExpertsSayType } from '../types'

import styles from './asExpertsSay.module.css'

const AsExpertsSay = ({ blockData: data }: { blockData: string }) => {
  const blockData = useMemo(() => {
    if (data) {
      return JSON.parse(data) as AsExpertsSayType
    }
  }, [data])

  return (
    <div className="xl:px-3">
      {/* pc端 */}
      <div className="mx-auto max-w-[1440px] max-xl:hidden">
        <h2
          className="!mb-11 !mt-0 font-miSansSemiBold520 text-pc-h2 !font-medium text-black"
          dangerouslySetInnerHTML={{ __html: blockData?.title || '' }}></h2>
        {blockData?.youtube_links && blockData?.youtube_links.length ? (
          <div>
            <div className="flex gap-4">
              {blockData?.youtube_links.map((item, index) => (
                <div
                  key={index}
                  className="h-[480px] w-[calc((100%-16px)/2)] overflow-hidden rounded-lg bg-gray-4">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`${item}&autoplay=1&mute=1`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen></iframe>
                </div>
              ))}
            </div>
          </div>
        ) : null}
        <div className="mt-4">
          <div className="flex gap-5">
            {blockData?.features.map((item, index) => (
              <div
                key={index}
                className="w-[calc((100%-90px)/3)] flex-1 shrink-0 rounded-xl bg-gray-0 px-7 py-9">
                <div
                  className="border-b border-gray-2 pb-6 font-miSansDemiBold450 text-5xl text-black"
                  dangerouslySetInnerHTML={{ __html: item.title }}></div>
                <div
                  className="mt-6 font-miSansDemiBold450 text-2xl text-black"
                  dangerouslySetInnerHTML={{ __html: item.sub_title }}></div>
                <div
                  className="mt-[10px] font-miSansMedium380 text-pc-lg text-gray-5"
                  dangerouslySetInnerHTML={{
                    __html: item.description,
                  }}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* mb端 */}
      <div className="xl:hidden">
        <div className="px-3">
          <h2
            className="!mb-[6px] !mt-0 font-miSansDemiBold450 !text-[18px]"
            dangerouslySetInnerHTML={{ __html: blockData?.title || '' }}></h2>
        </div>
        {blockData?.youtube_links && blockData?.youtube_links.length ? (
          <div className="mt-6">
            <div className={`w-full overflow-x-auto ${styles.hiddenscroll}`}>
              <div className="flex w-fit gap-2">
                {blockData?.youtube_links.map((item, index) => (
                  <div
                    key={index}
                    className={`h-[180px] w-[320px] shrink-0 overflow-hidden rounded-lg bg-gray-4 first:ml-3 last:mr-3`}>
                    <iframe
                      width="100%"
                      height="100%"
                      src={`${item}&autoplay=1&mute=1`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen></iframe>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        <div className="mt-6">
          <div className={`w-full overflow-x-auto ${styles.hiddenscroll}`}>
            <div className="flex w-fit gap-2">
              {blockData?.features.map((item, index) => (
                <div
                  key={index}
                  className="w-[320px] shrink-0 rounded-lg bg-gray-0 px-4 py-5 first:ml-3 last:mr-3">
                  <div
                    className="border-b border-gray-2 pb-3 font-miSansDemiBold450 text-3xl text-black"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <div
                    className="mt-3 font-miSansSemiBold520 text-base text-black"
                    dangerouslySetInnerHTML={{ __html: item.sub_title }}></div>
                  <div
                    className="mt-[10px] font-miSansRegular330 text-sm text-gray-5"
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AsExpertsSay
